import { createContext, useContext } from "react";

interface BetaFeaturesContextValue {
  isBetaEnabled: boolean;
  setIsBetaEnabled: (enabled: boolean) => void;
}

const BetaFeaturesContext = createContext<BetaFeaturesContextValue | null>(
  null
);

function useBetaFeatures(): BetaFeaturesContextValue {
  const context = useContext(BetaFeaturesContext);

  if (!context) {
    throw new Error(
      "useBetaFeatures must be used within a BetaFeaturesProvider"
    );
  }

  return context;
}

export { BetaFeaturesContext, useBetaFeatures };
export type { BetaFeaturesContextValue };
